<div class="post-edit-dialog dialog" [ngClass]="{'mobile-view': collaborationService?.isMobileScreen}">
    <div class="post-edit-dialog-header dialog-header">
        <h5>Edit Post</h5>
        <span class="post-edit-dialog-header-close dialog-close" (click)="close()" (keypress)="close()">
            <img alt="close" [src]="'images/close.svg' | assetUrl" class="black-icon cursor-pointer" draggable="false">
        </span>
    </div>
    <mat-dialog-content class="post-edit-dialog-content dialog-content">
        <exp-quill-rte [placeHolder]="placeHolder" [data]="dialogData.text" [isEditFlow]="true" (updateValueChange)="send($event)"
            [openEditForm]=true></exp-quill-rte>
    </mat-dialog-content>
</div>